const normalize = (str) =>
    str
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, "")
        .trim();

export default normalize;